// Recovered compiled webpack factory 64054. Edit this function expression; run npm run build.
(e, t) => {
  "use strict";
  (Object.defineProperty(t, "__esModule", { value: !0 }),
    !(function (e, t) {
      for (var r in t) Object.defineProperty(e, r, { enumerable: !0, get: t[r] });
    })(t, {
      bindSnapshot: function () {
        return i;
      },
      createAsyncLocalStorage: function () {
        return o;
      },
      createSnapshot: function () {
        return s;
      },
    }));
  let r = Object.defineProperty(
    Error("Invariant: AsyncLocalStorage accessed in runtime where it is not available"),
    "__NEXT_ERROR_CODE",
    { value: "E504", enumerable: !1, configurable: !0 },
  );
  class n {
    disable() {
      throw r;
    }
    getStore() {}
    run() {
      throw r;
    }
    exit() {
      throw r;
    }
    enterWith() {
      throw r;
    }
    static bind(e) {
      return e;
    }
  }
  let a = "undefined" != typeof globalThis && globalThis.AsyncLocalStorage;
  function o() {
    return a ? new a() : new n();
  }
  function i(e) {
    return a ? a.bind(e) : n.bind(e);
  }
  function s() {
    return a
      ? a.snapshot()
      : function (e, ...t) {
          return e(...t);
        };
  }
}
